import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df9230de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=df9230de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9230de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df9230de')) {
      api.createRecord('df9230de', component.options)
    } else {
      api.reload('df9230de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=df9230de&scoped=true", function () {
      api.rerender('df9230de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/region/index.vue"
export default component.exports